import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { Button as __unplugin_components_4 } from 'vant/es';
import 'vant/es/button/style/index';
import { Stepper as __unplugin_components_3 } from 'vant/es';
import 'vant/es/stepper/style/index';
import { Card as __unplugin_components_2 } from 'vant/es';
import 'vant/es/card/style/index';
import { Popup as __unplugin_components_1 } from 'vant/es';
import 'vant/es/popup/style/index';
import { SubmitBar as __unplugin_components_0 } from 'vant/es';
import 'vant/es/submit-bar/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "productDetails"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "imgBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.ProductDetailsData.goods_image,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.ProductDetailsData.goods_name))]), _c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.ProductDetailsData.price))])]), _c('div', {
    staticClass: "productDetails-box"
  }, [_c('h1', [_vm._v(i18n.tc("123"))]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.ProductDetailsData.description)
    }
  })])]), _c('div', {
    staticClass: "footer"
  }, [_c(__unplugin_components_0, {
    attrs: {
      "button-text": i18n.tc("277"),
      "button-color": "#3ccba6"
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('div', {
    staticClass: "box1",
    on: {
      "click": function ($event) {
        _vm.letGo(_vm.path = '/serviceMall/home');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/MH3.9/home.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(i18n.tc("0"))])]), _c('div', {
    staticClass: "box2",
    on: {
      "click": function ($event) {
        _vm.letGo(_vm.path = '/serviceMall/shoppingCart');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/MH3.9/activeshopCart.png"),
      "alt": ""
    }
  }), _c('span', [_vm._v(i18n.tc("121"))])])])], 1), _c(__unplugin_components_1, {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c(__unplugin_components_2, {
    attrs: {
      "num": _vm.num,
      "title": _vm.ProductDetailsData.goods_name,
      "thumb": _vm.ProductDetailsData.goods_image
    },
    scopedSlots: _vm._u([{
      key: "price",
      fn: function () {
        return [_c('span', [_vm._v(_vm._s(_vm.ProductDetailsData.price))])];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "content-box"
  }, [_c('span', [_vm._v(i18n.tc("278") + _vm._s(_vm.ProductDetailsData.unit))]), _c('div', {
    staticClass: "num"
  }, [_c('span', [_vm._v(i18n.tc("279"))]), _c(__unplugin_components_3, {
    attrs: {
      "min": "1"
    },
    model: {
      value: _vm.num,
      callback: function ($$v) {
        _vm.num = $$v;
      },
      expression: "num"
    }
  })], 1), _c(__unplugin_components_4, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    },
    on: {
      "click": _vm.addShopCart
    }
  }, [_vm._v(i18n.tc("277"))])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };